exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-form-item[data-v-eb382704] {\n  color: #1e0080;\n  font-weight: bold;\n  padding-right: 20px;\n  padding-left: 10px;\n}\n.el-input.bigger[data-v-eb382704] {\n  width: 530px;\n}\n.el-input.biggest[data-v-eb382704] {\n  width: 1040px;\n}\n.el-input.big[data-v-eb382704] {\n  width: 450px;\n  color: #3e67b9;\n}\n.el-input--small .el-input__inner[data-v-eb382704] {\n  width: 300px;\n}\n.el-date-editor.el-input[data-v-eb382704], .el-date-editor.el-input__inner[data-v-eb382704] {\n  width: 190px;\n}\n.el-checkbox__input.is-disabled + span.el-checkbox__label[data-v-eb382704] {\n  color: #1b91de;\n}\n.el-alert[data-v-eb382704] {\n  background-color: unset;\n  font-style: normal;\n  text-align: left;\n  display: inline;\n  font-weight: bold;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eb382704","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Titles.vue
// module id = vsGa
// module chunks = 1